import React, {Component} from 'react';
import "./NoticeArticle.css";
import calendar from "../../../../../assets/img/calendar.png"
import TreeViewMenu from "./TreeViewMenu";
import parse from "html-react-parser";
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../../../configuration";
import canvasDown from "../../../../../assets/img/canvasdown.png";
import canvasUp from "../../../../../assets/img/canvasup.png";

class NoticeArticle extends Component {

    constructor(props) {
        super(props);

        this.state = {
            title: "",
            body: "",
            createdDate: "",
            bodyError: "",
            titleError: ""

        };
        this.getArticle = this.getArticle.bind(this);
    }

    getArticle = () => {

        axios.get(RESOURCE_BASE_URL + 'api/articles/' + this.props.match.params.articleId)
            .then((res) => {
                this.setState({
                    title: res.data.title,
                    body: res.data.articleContent,
                    createdDate: res.data.createdDate
                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };

    componentDidMount() {
        this.getArticle();
    }

    render() {

        return (
            <div className="row notice-article-div notice-article-div-positioning ">
                <div className="row remove-margin-notice-article text-center-responsive">
                    <div className="spacer"></div>
                    <div className="spacer"></div>
                    <div className="col-md-offset-1" id="info-title-txt">インフォメーション</div>
                </div>
                <div className="col-md-8 custom-col-12 remove-padding-all">

                    <div className="notice-article-content ">
                        <div className="notice-article-div pull-left">
                            <div
                                className="col-md-4 custom-col-12 responsive-userAddress-table-mobile remove-padding-all ">

                                <TreeViewMenu/>
                            </div>
                            <div className="spacer"></div>
                            <div className="row">
                                <div className=" col-md-8 custom-col-12 text-center-responsive title-1 text-align-left">
                                    {this.state.title}
                                </div>
                                <div className="col-md-4 custom-col-12 text-center-responsive text-align-right">
                                    <img src={calendar}/>
                                    <b>
                                        {this.state.createdDate.substring(0, 4)} 年 {this.state.createdDate.substring(5, 7)} 月 {this.state.createdDate.substring(8, 10)} 日

                                    </b>
                                </div>
                            </div>
                            <div className="spacer"></div>
                            <div className="article-text-content set-padding-responsive article-img-responsive" id="home-article-div">
                                <p>
                                    {parse(this.state.body)}
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 custom-col-12 responsive-userAddress-table">
                    <TreeViewMenu/>
                </div>
            </div>
        )
    }

}

export default NoticeArticle;



// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/InformationNotice/ArticleItem/NoticeArticle.js